<template>
  <div style="margin:50px 0;height:100%">
      <a-radio-group v-model="current" button-style="solid" size="small">
        <a-radio-button :value="0">表格</a-radio-button>
        <a-radio-button :value="1">图表</a-radio-button>
      </a-radio-group>
      <a-select v-model="filterVal" style="width: 120px;float: right;" @change="handleChange">
        <a-select-option v-for="el in filterList" :key="el" :value="el">
          {{el}}
        </a-select-option>
      </a-select>
      <analyse-table ref="analyseTable" :result="res" :filterVal='filterVal' v-if="current == 0" />
      <analyse-chart ref="analyseChart" :result="res" :filterVal='filterVal' v-if="current == 1" />
  </div>
</template>

<script>
import AnalyseChart from './AnalyseChart.vue'
import AnalyseTable from './AnalyseTable.vue'

export default {
  components: { AnalyseTable, AnalyseChart },
  props:['res'],
  data(){
    return {
      current: 0,
      filterList: ['所有原料','组分有差异','组分无差异','拒绝原料'],
      filterVal: '组分有差异'
    }
  },
 
  mounted(){

  },
  methods: {
    handleChange(){}
  }
}
</script>

<style>

</style>